export const getCourseProgressUrl = (mode, studentBookingId, fallback) => {
  if (studentBookingId) return `/${mode === "admin" ? "admin" : "student"}/caurse-progress/${studentBookingId}`;
  return fallback || (mode === "admin" ? "/admin/enrolments" : "/student/my-courses");
};

export const getStageUrl = (url, mode, studentBookingId) => {
  if (!studentBookingId) return url;
  const stageMap = {
    "/student/enrol-new": "enrolment",
    "/student/usi-number": "usi-number",
    "/student/pre-training-review": "pre-training-review",
    "/student/lln-test": "lln-test",
    "/student/enrollment-documents": "documents",
    "/student/pre-class-preparation": "pre-class-preparation",
    "/student/pre-class-instruction": "pre-class-instruction",
    "/student/reading-resources": "reading-resources",
  };
  return stageMap[url] ? `/${mode === "admin" ? "admin" : "student"}/caurse-progress/${studentBookingId}/${stageMap[url]}` : url;
};
